module.exports = __webpack_public_path__ + "files/c49eb860cdaa054b5eda04e0550338fe.png";